import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography, Button, RemoveCircleOutlineIcon } from '@metarouter-private/mr-mui';
import { AceCodeEditor } from '@ion/components';

const SUBTITLE_TYPOGRAPHY_PROPS = {
  variant: 'subtitle1',
  color: 'secondary',
};

export default function DeployedIntegrationsList({ deployedIntegrations = [], integrationNamesById = {} }) {
  const [expandedIntegration, setExpandedIntegration] = useState(null);

  const handleClick = integrationId => {
    if (expandedIntegration === integrationId) {
      setExpandedIntegration(null);
    } else {
      setExpandedIntegration(integrationId);
    }
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Deployed integrations:</Typography>

      {deployedIntegrations.map(integration => {
        const integrationName = integrationNamesById[integration.id]?.name || integration.integrationName;

        return (
          <Stack key={integration.id} spacing={2}>
            <Stack spacing={2} direction="row" alignItems="center">
              <RemoveCircleOutlineIcon color="error" />

              <Typography {...SUBTITLE_TYPOGRAPHY_PROPS}>{integrationName}</Typography>

              <Button
                variant="outlined"
                data-test-id="showIntegrationDetailsButton"
                onClick={() => handleClick(integration.id)}
              >
                {expandedIntegration === integration.id ? 'Hide' : 'Show'} details
              </Button>
            </Stack>

            {expandedIntegration === integration.id && (
              <AceCodeEditor
                name={`integration-${integration.id}`}
                lang="json"
                value={JSON.stringify(integration, null, 2)}
                readOnly
                testId="integrationDetailsJson"
              />
            )}
          </Stack>
        );
      })}
    </Stack>
  );
}

DeployedIntegrationsList.propTypes = {
  deployedIntegrations: PropTypes.array,
  integrationNamesById: PropTypes.object,
};
